import { Button, Modal, Spinner, Text } from '@shared/widgets';

interface IBlockCardModalProps {
  show: boolean;
  onClose: () => void;
  onRequest: () => void;
  blocked: boolean;
  loading: boolean;
}

export const BlockCardModal = (props: IBlockCardModalProps) => {
  const save = async () => {
    await props.onRequest();
    props.onClose;
  };

  return (
    <Modal isOpen={props.show} onClose={props.onClose} title={(props.blocked ? 'Unfreeze' : 'Freeze') + ' card'}>
      {props.loading ? (
        <Spinner />
      ) : (
        <>
          <Text weight='medium'>Are you sure you want to request a card {props.blocked ? 'unfreeze' : 'freeze'}?</Text>
          <div className='mt-6'>
            <div className='flex gap-6'>
              <Button color='outlined' fullWidth onClick={props.onClose}>
                Decline
              </Button>
              <Button color='primary' fullWidth onClick={save}>
                Request
              </Button>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};
